import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy , inject} from '@angular/core';
import { AppConfigService } from 'app/core/config/app-config.service';
import { RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { TokenMonitorService } from './core/auth/token-monitor.service';
import { IdleLogoutService } from './core/auth/idle-logout.service';
import { AuthRepository } from './core/auth/auth.repository';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  readonly appConfig = inject(AppConfigService);
  private _destroy$ = new Subject<void>();

  constructor(
    private titleService: Title,
    private tokenMonitor: TokenMonitorService,
    private idleLogout: IdleLogoutService,
    private authRepository: AuthRepository
  ) {
    this.titleService.setTitle(this.appConfig.get('branding'));
  }

  ngOnInit(): void {
    // React to auth state changes: start services on login, stop on logout
    this.authRepository.$user
      .pipe(takeUntil(this._destroy$))
      .subscribe((user) => {
        if (user) {
          this.tokenMonitor.startMonitoring();
          this.idleLogout.start();
        } else {
          this.tokenMonitor.stopMonitoring();
          this.idleLogout.stop();
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    this.tokenMonitor.stopMonitoring();
    this.idleLogout.stop();
  }
}
